import i18n from 'src/i18n';
const configTable = () => {
    const tableColumns = [
        {
            prop: 'name',
            label: i18n.t('common_words.name'),
            align: 'center',
            sortable: true,
        },
        {
            prop: 'type',
            label: i18n.t('common_words.type'),
            align: 'center',
            sortable: true,
        },
        {
            prop: 'crops',
            label: i18n.t('common_words.crops'),
            align: 'center',
            sortable: true,
            formatter: (row) => {
                let crops = ''
                row.crops.forEach(crop => {
                    crops = `${crop.name}.${crops}`;
                });
                return crops;
            },
        },
    ];
    return { tableColumns };
}
export default configTable;